import { render, staticRenderFns } from "./underReview.vue?vue&type=template&id=03e616e8"
import script from "./underReview.vue?vue&type=script&lang=js"
export * from "./underReview.vue?vue&type=script&lang=js"
import style0 from "./underReview.vue?vue&type=style&index=0&id=03e616e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports